import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { CstIbsCbsStruct } from '@shared/services/structs/motor-fiscal/cst-ibs-cbs.struct';
import { CClassTribIbsCbsStruct } from '@shared/services/structs/motor-fiscal/c-class-trib-ibs-cbs.struct';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { RegraTributariaTribRegularSectionComponent } from './sections/trib-regular-section/regra-tributaria-trib-regular-section.component';

const minimoZero = Validators.min(0);

/** Aba Tributação Regular: ativação do tributo e seus campos. */
@Component({
    selector: 'app-regra-tributaria-trib-regular-tab',
    standalone: true,
    imports: [CommonModule, AtivacaoSectionCardComponent, RegraTributariaTribRegularSectionComponent],
    templateUrl: './regra-tributaria-trib-regular-tab.component.html',
    styleUrl: './regra-tributaria-trib-regular-tab.component.css',
})
export class RegraTributariaTribRegularTabComponent implements OnInit {
    @Input({ required: true }) form!: FormGroup;
    @Input() csts: CClassTribIbsCbsStruct[] = [];
    @Input() cclasstribs: CClassTribIbsCbsStruct[] = [];
    @Input() formulas: FormulaCatalogoItemStruct[] = [];

    private readonly codigos = ['cstIbsCbs', 'cclassIbsCbs'];
    private readonly aliquotas = ['pAliqEfetivaIbsUf', 'pAliqEfetivaIbsMunicipio', 'pAliqEfetivaCbs'];

    ngOnInit(): void {
        // Com a Tributação Regular e o IBS/CBS ativos, seus campos passam a ser obrigatórios (só calcula com o IBS/CBS).
        this.ativacaoControl.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.form.get('ibsCbs.isAtivo')?.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.sincronizarObrigatoriedade();
    }

    private sincronizarObrigatoriedade(): void {
        const ativo = !!this.ativacaoControl.value && !!this.form.get('ibsCbs.isAtivo')?.value;
        this.codigos.forEach(c => this.aplicarObrigatorio(this.regForm.get(c), ativo, [Validators.required]));
        // Alíquota preenchida é não vazia: zero é aceito, negativo não (o teto de 100 vem da máscara).
        this.aliquotas.forEach(c => this.aplicarObrigatorio(this.regForm.get(c), ativo, [Validators.required, minimoZero]));
    }

    private aplicarObrigatorio(control: AbstractControl | null, obrigatorio: boolean, validadores: ValidatorFn[]): void {
        if (!control) return;
        if (obrigatorio) {
            control.addValidators(validadores);
        } else {
            control.removeValidators(validadores);
        }
        control.updateValueAndValidity({ emitEvent: false });
    }

    public get regForm(): FormGroup {
        return this.form.get('tributacaoRegular') as FormGroup;
    }

    public get ativacaoControl(): FormControl {
        return this.regForm.get('isAtivo') as FormControl;
    }
}
